export const countriesArray = [
    {
        "code": "AF",
        "name": "Afghanistan",
        "slug": "afghanistan"
    },
    {
        "code": "AX",
        "name": "Åland Islands",
        "slug": "åland-islands"
    },
    {
        "code": "AL",
        "name": "Albania",
        "slug": "albania"
    },
    {
        "code": "DZ",
        "name": "Algeria",
        "slug": "algeria"
    },
    {
        "code": "AS",
        "name": "American Samoa",
        "slug": "american-samoa"
    },
    {
        "code": "AD",
        "name": "Andorra",
        "slug": "andorra"
    },
    {
        "code": "AO",
        "name": "Angola",
        "slug": "angola"
    },
    {
        "code": "AI",
        "name": "Anguilla",
        "slug": "anguilla"
    },
    {
        "code": "AQ",
        "name": "Antarctica",
        "slug": "antarctica"
    },
    {
        "code": "AG",
        "name": "Antigua and Barbuda",
        "slug": "antigua-and-barbuda"
    },
    {
        "code": "AR",
        "name": "Argentina",
        "slug": "argentina"
    },
    {
        "code": "AM",
        "name": "Armenia",
        "slug": "armenia"
    },
    {
        "code": "AW",
        "name": "Aruba",
        "slug": "aruba"
    },
    {
        "code": "AU",
        "name": "Australia",
        "slug": "australia"
    },
    {
        "code": "AT",
        "name": "Austria",
        "slug": "austria"
    },
    {
        "code": "AZ",
        "name": "Azerbaijan",
        "slug": "azerbaijan"
    },
    {
        "code": "BS",
        "name": "Bahamas",
        "slug": "bahamas"
    },
    {
        "code": "BH",
        "name": "Bahrain",
        "slug": "bahrain"
    },
    {
        "code": "BD",
        "name": "Bangladesh",
        "slug": "bangladesh"
    },
    {
        "code": "BB",
        "name": "Barbados",
        "slug": "barbados"
    },
    {
        "code": "BY",
        "name": "Belarus",
        "slug": "belarus"
    },
    {
        "code": "BE",
        "name": "Belgium",
        "slug": "belgium"
    },
    {
        "code": "BZ",
        "name": "Belize",
        "slug": "belize"
    },
    {
        "code": "BJ",
        "name": "Benin",
        "slug": "benin"
    },
    {
        "code": "BM",
        "name": "Bermuda",
        "slug": "bermuda"
    },
    {
        "code": "BT",
        "name": "Bhutan",
        "slug": "bhutan"
    },
    {
        "code": "BO",
        "name": "Bolivia",
        "slug": "bolivia"
    },
    {
        "code": "BQ",
        "name": "Bonaire, Sint Eustatius and Saba",
        "slug": "bonaire,-sint-eustatius-and-saba"
    },
    {
        "code": "BA",
        "name": "Bosnia and Herzegovina",
        "slug": "bosnia-and-herzegovina"
    },
    {
        "code": "BW",
        "name": "Botswana",
        "slug": "botswana"
    },
    {
        "code": "BV",
        "name": "Bouvet Island",
        "slug": "bouvet-island"
    },
    {
        "code": "BR",
        "name": "Brazil",
        "slug": "brazil"
    },
    {
        "code": "IO",
        "name": "British Indian Ocean Territory",
        "slug": "british-indian-ocean-territory"
    },
    {
        "code": "UM",
        "name": "US Minor Outlying Islands",
        "slug": "us-minor-outlying-islands"
    },
    {
        "code": "VG",
        "name": "Virgin Islands (British)",
        "slug": "virgin-islands-(british)"
    },
    {
        "code": "VI",
        "name": "Virgin Islands (U.S.)",
        "slug": "virgin-islands-(u.s.)"
    },
    {
        "code": "BN",
        "name": "Brunei Darussalam",
        "slug": "brunei-darussalam"
    },
    {
        "code": "BG",
        "name": "Bulgaria",
        "slug": "bulgaria"
    },
    {
        "code": "BF",
        "name": "Burkina Faso",
        "slug": "burkina-faso"
    },
    {
        "code": "BI",
        "name": "Burundi",
        "slug": "burundi"
    },
    {
        "code": "KH",
        "name": "Cambodia",
        "slug": "cambodia"
    },
    {
        "code": "CM",
        "name": "Cameroon",
        "slug": "cameroon"
    },
    {
        "code": "CA",
        "name": "Canada",
        "slug": "canada"
    },
    {
        "code": "CV",
        "name": "Cabo Verde",
        "slug": "cabo-verde"
    },
    {
        "code": "KY",
        "name": "Cayman Islands",
        "slug": "cayman-islands"
    },
    {
        "code": "CF",
        "name": "Central African Republic",
        "slug": "central-african-republic"
    },
    {
        "code": "TD",
        "name": "Chad",
        "slug": "chad"
    },
    {
        "code": "CL",
        "name": "Chile",
        "slug": "chile"
    },
    {
        "code": "CN",
        "name": "China",
        "slug": "china"
    },
    {
        "code": "CX",
        "name": "Christmas Island",
        "slug": "christmas-island"
    },
    {
        "code": "CC",
        "name": "Cocos Islands",
        "slug": "cocos-islands"
    },
    {
        "code": "CO",
        "name": "Colombia",
        "slug": "colombia"
    },
    {
        "code": "KM",
        "name": "Comoros",
        "slug": "comoros"
    },
    {
        "code": "CG",
        "name": "Congo",
        "slug": "congo"
    },
    {
        "code": "CD",
        "name": "Congo (DRC)",
        "slug": "congo-(drc)"
    },
    {
        "code": "CK",
        "name": "Cook Islands",
        "slug": "cook-islands"
    },
    {
        "code": "CR",
        "name": "Costa Rica",
        "slug": "costa-rica"
    },
    {
        "code": "HR",
        "name": "Croatia",
        "slug": "croatia"
    },
    {
        "code": "CU",
        "name": "Cuba",
        "slug": "cuba"
    },
    {
        "code": "CW",
        "name": "Curaçao",
        "slug": "curaçao"
    },
    {
        "code": "CY",
        "name": "Cyprus",
        "slug": "cyprus"
    },
    {
        "code": "CZ",
        "name": "Czech Republic",
        "slug": "czech-republic"
    },
    {
        "code": "DK",
        "name": "Denmark",
        "slug": "denmark"
    },
    {
        "code": "DJ",
        "name": "Djibouti",
        "slug": "djibouti"
    },
    {
        "code": "DM",
        "name": "Dominica",
        "slug": "dominica"
    },
    {
        "code": "DO",
        "name": "Dominican Republic",
        "slug": "dominican-republic"
    },
    {
        "code": "EC",
        "name": "Ecuador",
        "slug": "ecuador"
    },
    {
        "code": "EG",
        "name": "Egypt",
        "slug": "egypt"
    },
    {
        "code": "SV",
        "name": "El Salvador",
        "slug": "el-salvador"
    },
    {
        "code": "GQ",
        "name": "Equatorial Guinea",
        "slug": "equatorial-guinea"
    },
    {
        "code": "ER",
        "name": "Eritrea",
        "slug": "eritrea"
    },
    {
        "code": "EE",
        "name": "Estonia",
        "slug": "estonia"
    },
    {
        "code": "ET",
        "name": "Ethiopia",
        "slug": "ethiopia"
    },
    {
        "code": "FK",
        "name": "Falkland Islands",
        "slug": "falkland-islands"
    },
    {
        "code": "FO",
        "name": "Faroe Islands",
        "slug": "faroe-islands"
    },
    {
        "code": "FJ",
        "name": "Fiji",
        "slug": "fiji"
    },
    {
        "code": "FI",
        "name": "Finland",
        "slug": "finland"
    },
    {
        "code": "FR",
        "name": "France",
        "slug": "france"
    },
    {
        "code": "GF",
        "name": "French Guiana",
        "slug": "french-guiana"
    },
    {
        "code": "PF",
        "name": "French Polynesia",
        "slug": "french-polynesia"
    },
    {
        "code": "TF",
        "name": "French Southern Territories",
        "slug": "french-southern-territories"
    },
    {
        "code": "GA",
        "name": "Gabon",
        "slug": "gabon"
    },
    {
        "code": "GM",
        "name": "Gambia",
        "slug": "gambia"
    },
    {
        "code": "GE",
        "name": "Georgia",
        "slug": "georgia"
    },
    {
        "code": "DE",
        "name": "Germany",
        "slug": "germany"
    },
    {
        "code": "GH",
        "name": "Ghana",
        "slug": "ghana"
    },
    {
        "code": "GI",
        "name": "Gibraltar",
        "slug": "gibraltar"
    },
    {
        "code": "GR",
        "name": "Greece",
        "slug": "greece"
    },
    {
        "code": "GL",
        "name": "Greenland",
        "slug": "greenland"
    },
    {
        "code": "GD",
        "name": "Grenada",
        "slug": "grenada"
    },
    {
        "code": "GP",
        "name": "Guadeloupe",
        "slug": "guadeloupe"
    },
    {
        "code": "GU",
        "name": "Guam",
        "slug": "guam"
    },
    {
        "code": "GT",
        "name": "Guatemala",
        "slug": "guatemala"
    },
    {
        "code": "GG",
        "name": "Guernsey",
        "slug": "guernsey"
    },
    {
        "code": "GN",
        "name": "Guinea",
        "slug": "guinea"
    },
    {
        "code": "GW",
        "name": "Guinea-Bissau",
        "slug": "guinea-bissau"
    },
    {
        "code": "GY",
        "name": "Guyana",
        "slug": "guyana"
    },
    {
        "code": "HT",
        "name": "Haiti",
        "slug": "haiti"
    },
    {
        "code": "HM",
        "name": "Heard Island and McDonald Islands",
        "slug": "heard-island-and-mcdonald-islands"
    },
    {
        "code": "VA",
        "name": "Holy See",
        "slug": "holy-see"
    },
    {
        "code": "HN",
        "name": "Honduras",
        "slug": "honduras"
    },
    {
        "code": "HK",
        "name": "Hong Kong",
        "slug": "hong-kong"
    },
    {
        "code": "HU",
        "name": "Hungary",
        "slug": "hungary"
    },
    {
        "code": "IS",
        "name": "Iceland",
        "slug": "iceland"
    },
    {
        "code": "IN",
        "name": "India",
        "slug": "india"
    },
    {
        "code": "ID",
        "name": "Indonesia",
        "slug": "indonesia"
    },
    {
        "code": "CI",
        "name": "Côte d'Ivoire",
        "slug": "côte-d'ivoire"
    },
    {
        "code": "IR",
        "name": "Iran",
        "slug": "iran"
    },
    {
        "code": "IQ",
        "name": "Iraq",
        "slug": "iraq"
    },
    {
        "code": "IE",
        "name": "Ireland",
        "slug": "ireland"
    },
    {
        "code": "IM",
        "name": "Isle of Man",
        "slug": "isle-of-man"
    },
    {
        "code": "IL",
        "name": "Israel",
        "slug": "israel"
    },
    {
        "code": "IT",
        "name": "Italy",
        "slug": "italy"
    },
    {
        "code": "JM",
        "name": "Jamaica",
        "slug": "jamaica"
    },
    {
        "code": "JP",
        "name": "Japan",
        "slug": "japan"
    },
    {
        "code": "JE",
        "name": "Jersey",
        "slug": "jersey"
    },
    {
        "code": "JO",
        "name": "Jordan",
        "slug": "jordan"
    },
    {
        "code": "KZ",
        "name": "Kazakhstan",
        "slug": "kazakhstan"
    },
    {
        "code": "KE",
        "name": "Kenya",
        "slug": "kenya"
    },
    {
        "code": "KI",
        "name": "Kiribati",
        "slug": "kiribati"
    },
    {
        "code": "KW",
        "name": "Kuwait",
        "slug": "kuwait"
    },
    {
        "code": "KG",
        "name": "Kyrgyzstan",
        "slug": "kyrgyzstan"
    },
    {
        "code": "LA",
        "name": "Lao",
        "slug": "lao"
    },
    {
        "code": "LV",
        "name": "Latvia",
        "slug": "latvia"
    },
    {
        "code": "LB",
        "name": "Lebanon",
        "slug": "lebanon"
    },
    {
        "code": "LS",
        "name": "Lesotho",
        "slug": "lesotho"
    },
    {
        "code": "LR",
        "name": "Liberia",
        "slug": "liberia"
    },
    {
        "code": "LY",
        "name": "Libya",
        "slug": "libya"
    },
    {
        "code": "LI",
        "name": "Liechtenstein",
        "slug": "liechtenstein"
    },
    {
        "code": "LT",
        "name": "Lithuania",
        "slug": "lithuania"
    },
    {
        "code": "LU",
        "name": "Luxembourg",
        "slug": "luxembourg"
    },
    {
        "code": "MO",
        "name": "Macao",
        "slug": "macao"
    },
    {
        "code": "MK",
        "name": "Macedonia",
        "slug": "macedonia"
    },
    {
        "code": "MG",
        "name": "Madagascar",
        "slug": "madagascar"
    },
    {
        "code": "MW",
        "name": "Malawi",
        "slug": "malawi"
    },
    {
        "code": "MY",
        "name": "Malaysia",
        "slug": "malaysia"
    },
    {
        "code": "MV",
        "name": "Maldives",
        "slug": "maldives"
    },
    {
        "code": "ML",
        "name": "Mali",
        "slug": "mali"
    },
    {
        "code": "MT",
        "name": "Malta",
        "slug": "malta"
    },
    {
        "code": "MH",
        "name": "Marshall Islands",
        "slug": "marshall-islands"
    },
    {
        "code": "MQ",
        "name": "Martinique",
        "slug": "martinique"
    },
    {
        "code": "MR",
        "name": "Mauritania",
        "slug": "mauritania"
    },
    {
        "code": "MU",
        "name": "Mauritius",
        "slug": "mauritius"
    },
    {
        "code": "YT",
        "name": "Mayotte",
        "slug": "mayotte"
    },
    {
        "code": "MX",
        "name": "Mexico",
        "slug": "mexico"
    },
    {
        "code": "FM",
        "name": "Micronesia",
        "slug": "micronesia"
    },
    {
        "code": "MD",
        "name": "Moldova",
        "slug": "moldova"
    },
    {
        "code": "MC",
        "name": "Monaco",
        "slug": "monaco"
    },
    {
        "code": "MN",
        "name": "Mongolia",
        "slug": "mongolia"
    },
    {
        "code": "ME",
        "name": "Montenegro",
        "slug": "montenegro"
    },
    {
        "code": "MS",
        "name": "Montserrat",
        "slug": "montserrat"
    },
    {
        "code": "MA",
        "name": "Morocco",
        "slug": "morocco"
    },
    {
        "code": "MZ",
        "name": "Mozambique",
        "slug": "mozambique"
    },
    {
        "code": "MM",
        "name": "Myanmar",
        "slug": "myanmar"
    },
    {
        "code": "NA",
        "name": "Namibia",
        "slug": "namibia"
    },
    {
        "code": "NR",
        "name": "Nauru",
        "slug": "nauru"
    },
    {
        "code": "NP",
        "name": "Nepal",
        "slug": "nepal"
    },
    {
        "code": "NL",
        "name": "Netherlands",
        "slug": "netherlands"
    },
    {
        "code": "NC",
        "name": "New Caledonia",
        "slug": "new-caledonia"
    },
    {
        "code": "NZ",
        "name": "New Zealand",
        "slug": "new-zealand"
    },
    {
        "code": "NI",
        "name": "Nicaragua",
        "slug": "nicaragua"
    },
    {
        "code": "NE",
        "name": "Niger",
        "slug": "niger"
    },
    {
        "code": "NG",
        "name": "Nigeria",
        "slug": "nigeria"
    },
    {
        "code": "NU",
        "name": "Niue",
        "slug": "niue"
    },
    {
        "code": "NF",
        "name": "Norfolk Island",
        "slug": "norfolk-island"
    },
    {
        "code": "KP",
        "name": "North Korea",
        "slug": "north-korea"
    },
    {
        "code": "MP",
        "name": "Northern Mariana Islands",
        "slug": "northern-mariana-islands"
    },
    {
        "code": "NO",
        "name": "Norway",
        "slug": "norway"
    },
    {
        "code": "OM",
        "name": "Oman",
        "slug": "oman"
    },
    {
        "code": "PK",
        "name": "Pakistan",
        "slug": "pakistan"
    },
    {
        "code": "PW",
        "name": "Palau",
        "slug": "palau"
    },
    {
        "code": "PS",
        "name": "Palestine",
        "slug": "palestine"
    },
    {
        "code": "PA",
        "name": "Panama",
        "slug": "panama"
    },
    {
        "code": "PG",
        "name": "Papua New Guinea",
        "slug": "papua-new-guinea"
    },
    {
        "code": "PY",
        "name": "Paraguay",
        "slug": "paraguay"
    },
    {
        "code": "PE",
        "name": "Peru",
        "slug": "peru"
    },
    {
        "code": "PH",
        "name": "Philippines",
        "slug": "philippines"
    },
    {
        "code": "PN",
        "name": "Pitcairn",
        "slug": "pitcairn"
    },
    {
        "code": "PL",
        "name": "Poland",
        "slug": "poland"
    },
    {
        "code": "PT",
        "name": "Portugal",
        "slug": "portugal"
    },
    {
        "code": "PR",
        "name": "Puerto Rico",
        "slug": "puerto-rico"
    },
    {
        "code": "QA",
        "name": "Qatar",
        "slug": "qatar"
    },
    {
        "code": "XK",
        "name": "Republic of Kosovo",
        "slug": "republic-of-kosovo"
    },
    {
        "code": "RE",
        "name": "Réunion",
        "slug": "réunion"
    },
    {
        "code": "RO",
        "name": "Romania",
        "slug": "romania"
    },
    {
        "code": "RU",
        "name": "Russian Federation",
        "slug": "russian-federation"
    },
    {
        "code": "RW",
        "name": "Rwanda",
        "slug": "rwanda"
    },
    {
        "code": "BL",
        "name": "Saint Barthélemy",
        "slug": "saint-barthélemy"
    },
    {
        "code": "SH",
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "slug": "saint-helena,-ascension-and-tristan-da-cunha"
    },
    {
        "code": "KN",
        "name": "Saint Kitts and Nevis",
        "slug": "saint-kitts-and-nevis"
    },
    {
        "code": "LC",
        "name": "Saint Lucia",
        "slug": "saint-lucia"
    },
    {
        "code": "MF",
        "name": "Saint Martin",
        "slug": "saint-martin"
    },
    {
        "code": "PM",
        "name": "Saint Pierre and Miquelon",
        "slug": "saint-pierre-and-miquelon"
    },
    {
        "code": "VC",
        "name": "Saint Vincent and the Grenadines",
        "slug": "saint-vincent-and-the-grenadines"
    },
    {
        "code": "WS",
        "name": "Samoa",
        "slug": "samoa"
    },
    {
        "code": "SM",
        "name": "San Marino",
        "slug": "san-marino"
    },
    {
        "code": "ST",
        "name": "Sao Tome and Principe",
        "slug": "sao-tome-and-principe"
    },
    {
        "code": "SA",
        "name": "Saudi Arabia",
        "slug": "saudi-arabia"
    },
    {
        "code": "SN",
        "name": "Senegal",
        "slug": "senegal"
    },
    {
        "code": "RS",
        "name": "Serbia",
        "slug": "serbia"
    },
    {
        "code": "SC",
        "name": "Seychelles",
        "slug": "seychelles"
    },
    {
        "code": "SL",
        "name": "Sierra Leone",
        "slug": "sierra-leone"
    },
    {
        "code": "SG",
        "name": "Singapore",
        "slug": "singapore"
    },
    {
        "code": "SX",
        "name": "Sint Maarten (NL)",
        "slug": "sint-maarten-(nl)"
    },
    {
        "code": "SK",
        "name": "Slovakia",
        "slug": "slovakia"
    },
    {
        "code": "SI",
        "name": "Slovenia",
        "slug": "slovenia"
    },
    {
        "code": "SB",
        "name": "Solomon Islands",
        "slug": "solomon-islands"
    },
    {
        "code": "SO",
        "name": "Somalia",
        "slug": "somalia"
    },
    {
        "code": "ZA",
        "name": "South Africa",
        "slug": "south-africa"
    },
    {
        "code": "GS",
        "name": "South Georgia and the South Sandwich Islands",
        "slug": "south-georgia-and-the-south-sandwich-islands"
    },
    {
        "code": "KR",
        "name": "South Korea",
        "slug": "south-korea"
    },
    {
        "code": "SS",
        "name": "South Sudan",
        "slug": "south-sudan"
    },
    {
        "code": "ES",
        "name": "Spain",
        "slug": "spain"
    },
    {
        "code": "LK",
        "name": "Sri Lanka",
        "slug": "sri-lanka"
    },
    {
        "code": "SD",
        "name": "Sudan",
        "slug": "sudan"
    },
    {
        "code": "SR",
        "name": "Suriname",
        "slug": "suriname"
    },
    {
        "code": "SJ",
        "name": "Svalbard and Jan Mayen",
        "slug": "svalbard-and-jan-mayen"
    },
    {
        "code": "SZ",
        "name": "Swaziland",
        "slug": "swaziland"
    },
    {
        "code": "SE",
        "name": "Sweden",
        "slug": "sweden"
    },
    {
        "code": "CH",
        "name": "Switzerland",
        "slug": "switzerland"
    },
    {
        "code": "SY",
        "name": "Syria",
        "slug": "syria"
    },
    {
        "code": "TW",
        "name": "Taiwan",
        "slug": "taiwan"
    },
    {
        "code": "TJ",
        "name": "Tajikistan",
        "slug": "tajikistan"
    },
    {
        "code": "TZ",
        "name": "Tanzania",
        "slug": "tanzania"
    },
    {
        "code": "TH",
        "name": "Thailand",
        "slug": "thailand"
    },
    {
        "code": "TL",
        "name": "Timor-Leste",
        "slug": "timor-leste"
    },
    {
        "code": "TG",
        "name": "Togo",
        "slug": "togo"
    },
    {
        "code": "TK",
        "name": "Tokelau",
        "slug": "tokelau"
    },
    {
        "code": "TO",
        "name": "Tonga",
        "slug": "tonga"
    },
    {
        "code": "TT",
        "name": "Trinidad and Tobago",
        "slug": "trinidad-and-tobago"
    },
    {
        "code": "TN",
        "name": "Tunisia",
        "slug": "tunisia"
    },
    {
        "code": "TR",
        "name": "Turkey",
        "slug": "turkey"
    },
    {
        "code": "TM",
        "name": "Turkmenistan",
        "slug": "turkmenistan"
    },
    {
        "code": "TC",
        "name": "Turks and Caicos Islands",
        "slug": "turks-and-caicos-islands"
    },
    {
        "code": "TV",
        "name": "Tuvalu",
        "slug": "tuvalu"
    },
    {
        "code": "UG",
        "name": "Uganda",
        "slug": "uganda"
    },
    {
        "code": "UA",
        "name": "Ukraine",
        "slug": "ukraine"
    },
    {
        "code": "AE",
        "name": "United Arab Emirates",
        "slug": "united-arab-emirates"
    },
    {
        "code": "GB",
        "name": "United Kingdom",
        "slug": "united-kingdom"
    },
    {
        "code": "US",
        "name": "USA",
        "slug": "usa"
    },
    {
        "code": "UY",
        "name": "Uruguay",
        "slug": "uruguay"
    },
    {
        "code": "UZ",
        "name": "Uzbekistan",
        "slug": "uzbekistan"
    },
    {
        "code": "VU",
        "name": "Vanuatu",
        "slug": "vanuatu"
    },
    {
        "code": "VE",
        "name": "Venezuela",
        "slug": "venezuela"
    },
    {
        "code": "VN",
        "name": "Vietnam",
        "slug": "vietnam"
    },
    {
        "code": "WF",
        "name": "Wallis and Futuna",
        "slug": "wallis-and-futuna"
    },
    {
        "code": "EH",
        "name": "Western Sahara",
        "slug": "western-sahara"
    },
    {
        "code": "YE",
        "name": "Yemen",
        "slug": "yemen"
    },
    {
        "code": "ZM",
        "name": "Zambia",
        "slug": "zambia"
    },
    {
        "code": "ZW",
        "name": "Zimbabwe",
        "slug": "zimbabwe"
    }
]